import { render, staticRenderFns } from "./modalCancelandoColetaAmostra.vue?vue&type=template&id=6a09d315&"
import script from "./modalCancelandoColetaAmostra.vue?vue&type=script&lang=js&"
export * from "./modalCancelandoColetaAmostra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports